(function () {
  'use strict';

  function initSlider(root) {
    if (!root || root.dataset.cpSliderReady === '1') return;
    var track = root.querySelector('[data-slider-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slider-slide]'));
    if (!track || slides.length === 0) return;

    root.dataset.cpSliderReady = '1';

    var viewport = root.querySelector('[data-slider-viewport]') || root.querySelector('.hero-slider__viewport');
    var prevBtn = root.querySelector('[data-slider-prev]');
    var nextBtn = root.querySelector('[data-slider-next]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-slider-dot]'));
    var current = 0;
    var timer = null;
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 5000;
    var didSwipe = false;

    function getActiveSlideHeight() {
      var slide = slides[current];
      if (!slide) return 0;
      var img = slide.querySelector('.hero-slider__image');
      if (img && img.offsetHeight > 0) {
        return img.offsetHeight;
      }
      return slide.offsetHeight;
    }

    function syncViewportHeight(animate) {
      if (!viewport) return;
      if (!root.classList.contains('hero-slider--adaptive')) {
        viewport.style.height = '';
        return;
      }
      var h = getActiveSlideHeight();
      if (h > 0) {
        if (!animate) {
          var prevTrans = viewport.style.transition;
          viewport.style.transition = 'none';
          viewport.style.height = h + 'px';
          void viewport.offsetHeight;
          viewport.style.transition = prevTrans;
        } else {
          viewport.style.height = h + 'px';
        }
      }
    }

    function goTo(index, animateHeight) {
      current = ((index % slides.length) + slides.length) % slides.length;
      track.style.transform = 'translateX(' + (-100 * current) + '%)';
      dots.forEach(function (dot, idx) {
        dot.classList.toggle('is-active', idx === current);
      });
      syncViewportHeight(Boolean(animateHeight));
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function startAutoplay() {
      if (!autoplay || slides.length < 2) return;
      stopAutoplay();
      timer = setInterval(function () {
        goTo(current + 1, true);
      }, speed);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(current - 1, true);
        startAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(current + 1, true);
        startAutoplay();
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(dot.getAttribute('data-slider-dot'), 10);
        if (!isNaN(idx)) {
          goTo(idx, true);
          startAutoplay();
        }
      });
    });

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    /* Touch swipe support for mobile & tablet */
    if (slides.length > 1) {
      var startX = 0;
      var startY = 0;
      var tracking = false;

      root.addEventListener('touchstart', function (ev) {
        if (!ev.touches || ev.touches.length !== 1) return;
        startX = ev.touches[0].clientX;
        startY = ev.touches[0].clientY;
        tracking = true;
        didSwipe = false;
      }, { passive: true });

      root.addEventListener('touchend', function (ev) {
        if (!tracking || !ev.changedTouches || ev.changedTouches.length === 0) return;
        tracking = false;
        var dx = ev.changedTouches[0].clientX - startX;
        var dy = ev.changedTouches[0].clientY - startY;
        if (Math.abs(dx) > 36 && Math.abs(dx) > Math.abs(dy) * 1.2) {
          didSwipe = true;
          if (dx < 0) {
            goTo(current + 1, true);
          } else {
            goTo(current - 1, true);
          }
          startAutoplay();
        }
      }, { passive: true });

      root.addEventListener('click', function (ev) {
        if (didSwipe) {
          didSwipe = false;
          ev.preventDefault();
        }
      }, true);
    }

    /* Observe image loads & resizes so adaptive height stays pixel-accurate */
    slides.forEach(function (slide, idx) {
      var img = slide.querySelector('.hero-slider__image');
      if (img) {
        img.addEventListener('load', function () {
          if (idx === current) syncViewportHeight(false);
        });
      }
    });

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(function () {
        syncViewportHeight(false);
      });
      slides.forEach(function (slide) {
        var img = slide.querySelector('.hero-slider__image') || slide;
        ro.observe(img);
      });
    } else {
      window.addEventListener('resize', function () {
        syncViewportHeight(false);
      });
    }

    /* Shopify Theme Editor block selection support */
    root.cpSelectBlock = function (blockId) {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-block-id') === blockId) {
          stopAutoplay();
          goTo(i, true);
          break;
        }
      }
    };
    root.cpResume = startAutoplay;

    goTo(0, false);
    startAutoplay();
  }

  function initAll() {
    document.querySelectorAll('[data-slider]').forEach(initSlider);
  }

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', initAll);
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:block:select', function (ev) {
    var blockId = ev.detail && ev.detail.blockId;
    if (!blockId || !ev.target) return;
    var slider = ev.target.closest ? ev.target.closest('[data-slider]') : null;
    if (slider && typeof slider.cpSelectBlock === 'function') {
      slider.cpSelectBlock(blockId);
    }
  });
  document.addEventListener('shopify:block:deselect', function (ev) {
    if (!ev.target) return;
    var slider = ev.target.closest ? ev.target.closest('[data-slider]') : null;
    if (slider && typeof slider.cpResume === 'function') {
      slider.cpResume();
    }
  });
})();
